import { useFeatureFlagSplit } from '@verantos-dev/app-state-base';

import {
  useConceptGroupsListDialogContext,
  ConceptGroupsDialogActionType,
  DialogType,
} from '../context/ConceptGroupsListDialogContext';
import { ConceptGroupDetailModal } from './ConceptGroupDetailModal/ConceptGroupDetailModal';
import { ConceptGroupDetailsDialog } from './ConceptGroupDetailsDialog/ConceptGroupDetailsDialog';
import { DeleteConceptGroupModal } from '../containers/DeleteConceptGroupModal';

// TODO: cleanup with concept_group_list_view_gen3 ff
const FF_LIST_VIEW_GEN3 = 'concept_group_list_view_gen3';

export const ConceptGroupsListDialogs = () => {
  const { state, dispatch } = useConceptGroupsListDialogContext();
  // Gen-3 list detail: the row-click opens the shared Ready-view detail in a
  // modal (ConceptGroupDetailModal); flag OFF keeps the legacy full-screen
  // datagrid dialog (ConceptGroupDetailsDialog, still used directly by
  // feature-epi-chat regardless of this flag).
  // TODO: cleanup with concept_group_list_view_gen3 ff
  const isGen3ListView = useFeatureFlagSplit(FF_LIST_VIEW_GEN3);

  if (state.activeDialog === DialogType.DETAILS && state.data?.conceptGroupId) {
    const onClose = () => dispatch({ type: ConceptGroupsDialogActionType.CLOSE_DIALOG });
    // TODO: cleanup with concept_group_list_view_gen3 ff
    return isGen3ListView ? (
      <ConceptGroupDetailModal conceptGroupId={state.data.conceptGroupId} onClose={onClose} />
    ) : (
      <ConceptGroupDetailsDialog conceptGroupId={state.data.conceptGroupId} onClose={onClose} />
    );
  }

  if (state.activeDialog === DialogType.DELETE && state.data?.conceptGroupId) {
    return <DeleteConceptGroupModal />;
  }

  return null;
};
